import { Navigate, useLocation } from 'react-router';
import PageNotFound from '../common/lib/PageNotFound';
import type { MultiLang } from '../config';

interface Props {
    lang: MultiLang;
}

const NAME = 'credits';

const getRedirectUrl = (pathname: string, search: string): string => {
    const query = new URLSearchParams(search);
    const matches = (pathname || '').match(new RegExp(`^/modules/${NAME}(?:/+(.*))?$`));
    if (matches === null) {
        return '';
    }
    switch (matches[1] || '') {
        case '':
        case 'index.php': {
            const id = query.get('id');
            if (id !== null) {
                return id.match(/^\d+$/) !== null ? `/${NAME}/${id}` : '';
            }
            return `/${NAME}`;
        }
        case 'aboutus.php':
            return `/${NAME}`;
    }
    return '';
};

const CreditsXoopsPathRedirect = (props: Props) => {
    const { lang } = props;
    const location = useLocation();
    const url = getRedirectUrl(location.pathname, location.search);
    if (url === '') {
        return <PageNotFound lang={lang} />;
    }
    return <Navigate to={url} replace />;
};

export default CreditsXoopsPathRedirect;
